import { GET_CLUB_MEMBERS } from "constants/clubMembers";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CLUB_MEMBERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
